import React from "react";
import * as Bananas from "bananas-commerce-admin";

import ErrorCard from "@/extensions/klarahill/components/ErrorCard";
import CustomScheduleCard from "@/extensions/mediahouse/components/CustomScheduleCard";
import ScheduleCard from "@/extensions/mediahouse/components/ScheduleCard";
import SchedulesCard from "@/extensions/mediahouse/components/SchedulesCard";
import { PublishingRuleRetrieveSchema } from "@/extensions/mediahouse/types";

export interface PublishingRulesTabProps {
  schedules: PublishingRuleRetrieveSchema[];
  refresh: () => void;
}

const PublishingRulesTab: React.FC<PublishingRulesTabProps> = ({
  schedules,
  refresh,
}) => {
  if (schedules.length === 0) {
    return (
      <Bananas.Content layout="fullWidth">
        <ErrorCard errorMessage="Hittade inga utgivningsschema för ditt urval." />
      </Bananas.Content>
    );
  }

  return (
    <Bananas.Content layout="fullWidth">
      <SchedulesCard>
        {schedules.map((schedule) => (
          <ScheduleCard
            key={schedule.group_id}
            refresh={refresh}
            schedule={schedule}
          />
        ))}
      </SchedulesCard>
      <CustomScheduleCard />
    </Bananas.Content>
  );
};

export default PublishingRulesTab;
